import { render, staticRenderFns } from "./PendapatanBunga.vue?vue&type=template&id=600b2bfe"
import script from "./PendapatanBunga.vue?vue&type=script&lang=js"
export * from "./PendapatanBunga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports